export default __webpack_public_path__ + "static/O0168-e3a5740e0d8896702456676f496cc111.png";